/**
 * PreferencesModal — the NAVBAR's opener for the preferences body.
 *
 * Diamond Architecture: Client Component for user preferences.
 * The globe button in `NavbarShell`'s right cluster, and nothing else: the
 * CONTENT (auto-translate, the language anchors, currency, units) lives in
 * {@link PreferencesBody}, which this and the profile hub's
 * {@link PreferencesRow} both render.
 *
 * ⚠ THIS OPENER DOES NOT EXIST ON A PHONE, and that is why the split happened
 * (F5). `NavbarShell`'s `<header>` is `sticky top-0 hidden … md:block`, so
 * below the `md` breakpoint this button is not rendered at all — for the whole
 * life of the component it was the app's ONLY language control, which meant a
 * phone had none. The second opener is a row on `/profile`, in both auth
 * states, with a no-JavaScript leg; see `PreferencesRow`'s module doc.
 */
import { useTranslations } from '@/shared/i18n/useTranslations';
import { Button } from '@letsgethome/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@letsgethome/ui/dialog';
import { Globe } from 'lucide-react';

import { PreferencesBody } from '../preferences/PreferencesBody';

export function PreferencesModal() {
  const t = useTranslations('preferences');
  const navT = useTranslations('nav');

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={navT('language')}>
          <Globe className="h-5 w-5" />
        </Button>
      </DialogTrigger>

      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('title')}</DialogTitle>
        </DialogHeader>

        <PreferencesBody />
      </DialogContent>
    </Dialog>
  );
}
